<template lang="pug">
    .footer
        .footer__main
            .container
                .row.row-eq-height
                    .col-md-12
                        PmFooterOption(v-for="option in lenguageNavSelected", :data="option", :ispad="lenguage != 'EN'")
                    .col-md-12
                        .reserved-center
                            | ©2019 ATP -
                            a {{ lenguageOthers.rights }}
                            router-link(:to="lenguageOthers.breadcrumb.link") {{ lenguageOthers.breadcrumb.name }}
                            a(:href="pdfatp", target="blank") {{ lenguageOthers.policyATP }}
                            a(:href="pdffiber", target="blank") {{ lenguageOthers.policyFIBER }}
                            a(:href="pdfATPPE", target="blank") {{ lenguageOthers.policyATPPE }}
                            a(:href="pdfRDFPPE", target="blank") {{ lenguageOthers.policyFIBERPE }}
                            a(:href="pdffiberco", target="blank") {{ lenguageOthers.policyFIBERCO }}
                            router-link(:to="lenguageOthers.breadcrumb2.link") {{ lenguageOthers.breadcrumb2.name }}
                            a.no-span {{ lenguageOthers.investment }}
                            a(href="https://www.digitalbridge.com/", target="_blank" , style="border:0px; padding: 0px")
                                img(:src="digital_bridge_new", width="90")

                        .reserved-right()
                            img(:src="logo_white", width="200" style="margin-bottom:70px; top:35px")


</template>

<script>
import digital_bridge_new from '@img/digital-new-logo.png'
import PmFooterOption from '@components/atoms/PmFooterOption.vue';
import pdfatp from '@pdf/manualatp.pdf'
import pdffiber from '@pdf/manualfiber.pdf'
import pdfATPPE from '@pdf/manualATPPE.pdf'
import pdfRDFPPE from '@pdf/manualRDFPPE.pdf'
import pdffiberco from '@pdf/ATPFIBERCO.pdf'
import logo_white from '@img/logo-white.png'

export default {
    props: ["lang"],
    created: function(){
        this.$data.lenguage = this.$route.meta.lang
    },
    components: {
        PmFooterOption
    },
    data: function(){
        return {
            pdfatp,
            pdffiber,
            pdfATPPE,
            pdfRDFPPE,
            pdffiberco,
            digital_bridge_new: digital_bridge_new,
            logo_white: logo_white,
            lenguage: 'EN',
            othersEn: {
                rights: 'Rights Reserved',
                investment: 'ATP is an investment of',
                policyATP: 'Data Policy ATP CO',
                policyFIBER: 'Data Policy ATP FIBER CO',
                policyATPPE: 'Data Policy ATP PE',
                policyFIBERPE: 'Data Policy RDFP PE',
                policyFIBERCO: 'Access to Infrastructure Conditions',
                breadcrumb2: {name:'Ecuador Environmental News', link:'/en/news-environmental'},
                breadcrumb: {name:'Terms of Use', link:'/en/terms-of-use'},
            },
            othersEs: {
                rights: 'Todos los Derechos Reservados',
                investment: 'ATP es una compañia de',
                policyATP: 'Política de datos ATP CO',
                policyFIBER: 'Política de datos ATP FIBRA CO',
                policyATPPE: 'Política de datos ATP PE',
                policyFIBERPE: 'Política de datos RDFP PE',
                policyFIBERCO: 'Condiciones Compartición',
                breadcrumb2: {name:'Ecuador Noticias Ambientales', link:'/es/noticias-ambientales'},
                breadcrumb: {name:'Termino de Uso', link:'/es/terminos-de-uso'}
            },

            navOptionsEn: [
                {title: "ABOUT ATP", link: "/en/about/what-we-do", options: [
                    {title: "What We Do", link: "/en/about/what-we-do"},
                    {title: "Our History", link: "/en/about/our-history"},
                    {title: "Management Team", link: "/en/about/management-team"},
                    {title: "Our Portfolio", link: "/en/about/our-portfolio"},
                    {title: "Our Vision for 5G", link: "/en/about/our-vision-for-5g"},
                ]},
                {title: "PRODUCTS", link: "/en/products/small-cells", options: [
                    {title: "Small Cells", link: "/en/products/small-cells"},
                    {title: "DAS", link: "/en/products/das"},
                    {title: "Optical Fiber", link: "/en/products/optical-fiber"},
                    {title: "Towers and Rooftops", link: "/en/products/towers-and-rooftops"},
                ]},
                {title: "PORTFOLIO MANAGEMENT", link: "/en/portfolio/property-developers", options: [
                    {title: "Property Developers", link: "/en/portfolio/property-developers"},
                    {title: "Land Owners", link: "/en/portfolio/land-owners"},
                    {title: "Commercial and Real Estate Owners", link: "/en/portfolio/comercial-and-real-estate-owners"},
                    {title: "Large Venues", link: "/en/portfolio/large-venues"},
                    {title: "Infrastructure Owners", link: "/en/portfolio/infrastructure-owners"},
                    {title: "Public Service Companies", link: "/en/portfolio/public-services-companies"},
                    {title: "City and Street Furniture Owners", link: "/en/portfolio/city-and-street-furniture-owners"},
                ]},
                {title: "OUR SERVICES", link: "/en/services/we-lease", options: [
                    {title: "We Lease", link: "/en/services/we-lease"},
                    {title: "We Build", link: "/en/services/we-build"},
                    {title: "We Manage", link: "/en/services/we-manage"},
                    {title: "We Buy", link: "/en/services/we-buy"}
                ]},
                {title: "MUNICIPALITIES", link: "/en/municipalities/smart-cities", options: [
                    {title: "Smart Cities", link: "/en/municipalities/smart-cities"},
                    {title: "Internet of Things", link: "/en/municipalities/internet-of-things"},
                    {title: "Public Safety", link: "/en/municipalities/public-safety"}
                ]},
                {title: "CAREERS", link: "/en/careers", options: []},
                {title: "PRESS", link: "/en/press", options: []},
                {title: "PUBLICATIONS", link: "/en/publications", options: []},
                {title: "CONTACT", link: "/en/contact", options: []},
            ],


            navOptionsEs: [
               {title: "ACERCA DE ATP", link: "/es/acerca-de-atp/que-hacemos", options: [
                    {title: "Qué Hacemos", link: "/es/acerca-de-atp/que-hacemos"},
                    {title: "Nuestra Historia", link: "/es/acerca-de-atp/nuestra-historia"},
                    {title: "Equipo Directivo", link: "/es/acerca-de-atp/equipo-directivo"},
                    {title: "Nuestro Portafolio", link: "/es/acerca-de-atp/nuestro-portafolio"},
                    {title: "Nuestra Visión 5G", link: "/es/acerca-de-atp/nuestra-vision-5g"},
                ]},
                {title: "PRODUCTOS", link: "/es/productos/small-cells", options: [
                    {title: "Small Cells", link: "/es/productos/small-cells"},
                    {title: "DAS", link: "/es/productos/das"},
                    {title: "Fibra Óptica", link: "/es/productos/fibra-optica"},
                    {title: "Torres y Azoteas", link: "/es/productos/torres-y-azoteas"},
                ]},
                {title: "PORTAFOLIO", link: "/es/portafolio/desarrolladores-de-bienes-raices", options: [
                    {title: "Desarrolladores de Bienes Raíces", link: "/es/portafolio/desarrolladores-de-bienes-raices"},
                    {title: "Propietarios de Predios", link: "/es/portafolio/propietarios-de-predios"},
                    {title: "Propietarios de Inmuebles Comerciales", link: "/es/portafolio/propietarios-de-inmuebles-comerciales"},
                    {title: "Propietarios de Inmuebles Insignia", link: "/es/portafolio/propietarios-de-inmuebles-insignia"},
                    {title: "Dueños de Infraestructura", link: "/es/portafolio/dueños-de-infraestructura"},
                    {title: "Organizaciones de Servicios Públicos", link: "/es/portafolio/organizaciones-de-servicios-publicos"},
                    {title: "Propietarios de Mobiliario Urbano", link: "/es/portafolio/propietarios-de-mobiliario-urbano"},
                ]},
                {title: "SERVICIOS", link: "/es/servicios/alquilamos", options: [
                    {title: "Alquilamos", link: "/es/servicios/alquilamos"},
                    {title: "Construimos", link: "/es/servicios/construimos"},
                    {title: "Administramos", link: "/es/servicios/administramos"},
                    {title: "Compramos", link: "/es/servicios/compramos"}
                ]},
                {title: "MUNICIPIOS", link: "/es/municipios/ciudades-inteligentes", options: [
                    {title: "Ciudades Inteligentes", link: "/es/municipios/ciudades-inteligentes"},
                    {title: "Internet of Things (IoT)", link: "/es/municipios/internet-of-things"},
                    {title: "Seguridad Pública", link: "/es/municipios/seguridad-publica"}
                ]},
                {title: "OPORTUNIDADES", link: "/es/oportunidades", options: []},
                {title: "NOTICIAS", link: "/es/noticias", options: []},
                {title: "PUBLICACIONES", link: "/es/publicaciones", options: []},
                {title: "CONTACTO", link: "/es/contacto", options: []},
            ],
        }
    },
    computed: {
        lenguageNavSelected: function(){
            return this.$data.lenguage == 'EN'? this.$data.navOptionsEn : this.$data.navOptionsEs
        },
        lenguageOthers: function(){
            return this.$data.lenguage == 'EN'? this.$data.othersEn : this.$data.othersEs
        }
    },
    watch: {
        lang: {
            deep: true,
            handler(newValue, oldValue) {
                console.log(newValue)
            }
        },
        '$route'(to, from) {
            this.$data.lenguage = this.$route.meta.lang
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/molecules/PmFooter.vue